import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type {
	StraightenerProductSize,
	StraightenerRunRow,
} from "../models/StraightenerRuns";

export interface GetStraightenerRunsParams {
	start: string;
	end: string;
	productSizeId?: number | null;
	productTypeId?: number | null;
	signal?: AbortSignal;
}

export const getStraightenerRuns = async ({
	start,
	end,
	productSizeId = null,
	productTypeId = null,
	signal,
}: GetStraightenerRunsParams): Promise<StraightenerRunRow[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "Start", value: start },
		{ name: "End", value: end },
		{ name: "ProductSizeId", value: productSizeId },
		{ name: "ProductTypeId", value: productTypeId },
	];

	const spName = "[MILL].[GetStraightenerRunsReport]";
	const resp = await apiService.callV2(spName, parameters, signal);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching straightener runs");
	}
	return get(resp, "data.tables[0].rows", []) as StraightenerRunRow[];
};

export interface GetStraightenerPickersParams {
	signal?: AbortSignal;
}

export const getStraightenerPickers = async ({
	signal,
}: GetStraightenerPickersParams): Promise<StraightenerProductSize[]> => {
	const apiService = new MESApiService();

	const spName = "[MILL].[GetStraightenerReportPickers]";
	const resp = await apiService.callV2(spName, [], signal);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching straightener pickers");
	}
	return get(resp, "data.tables[0].rows", []) as StraightenerProductSize[];
};
